export default {
  email: {
    presence: { allowEmpty: false, message: "is required" },
    email: false,
    length: {
      maximum: 64
    }
  }
};
